// extracted by mini-css-extract-plugin
module.exports = {"picWrapper":"PictureWidget_picWrapper__29lj4","imageWrapper":"PictureWidget_imageWrapper__1evQo","button":"PictureWidget_button__4pMkK","floating":"PictureWidget_floating__kk1n9"};